/**
 * Base props and logic for ProfileWelcomeCard
 * Shared between mobile and desktop versions
 */

export interface ProfileWelcomeCardBaseProps {
  profile?: {
    first_name?: string
    last_name?: string
    profile_picture_url?: string
    companies_of_interest_buy?: string[]
    companies_of_interest_sell?: string[]
  }
}

/**
 * Base component with shared logic
 * Contains only business logic, no UI styling
 */
export const ProfileWelcomeCardBase = {
  /**
   * Gets the user's display name
   */
  getDisplayName: (profile?: ProfileWelcomeCardBaseProps['profile']): string => {
    if (!profile?.first_name) return 'User'
    return `${profile.first_name} ${profile.last_name || ''}`.trim()
  }
}

